import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

/**
 * Componente para mostrar mensajes de error con opción de reintentar
 */
const ErrorMessage = ({ 
  title = 'Error', 
  message = 'Ha ocurrido un error inesperado', 
  onRetry = null,
  compact = false,
  className = '' 
}) => {
  if (compact) {
    return (
      <div className={`flex items-center justify-between p-3 rounded-lg border ${className}`} style={{background:'rgba(237,64,104,.06)', borderColor:'rgba(237,64,104,.25)'}}>
        <div className="flex items-center space-x-2">
          <AlertCircle className="h-4 w-4 flex-shrink-0" style={{color:'var(--yool-error)'}} />
          <div>
            <p className="text-sm font-medium" style={{color:'var(--yool-error)'}}>{title}</p>
            <p className="text-sm" style={{color:'var(--yool-error)'}}>{message}</p>
          </div>
        </div>
        {onRetry && (
          <button
            onClick={onRetry}
            className="flex items-center space-x-1 px-3 py-1 text-sm font-medium rounded-md transition-colors"
            style={{color:'var(--yool-error)', background:'rgba(237,64,104,.10)'}}
          >
            <RefreshCw className="h-3 w-3" />
            <span>Reintentar</span>
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={`text-center p-8 ${className}`}>
      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full mb-4" style={{background:'rgba(237,64,104,.10)'}}>
        <AlertCircle className="h-6 w-6" style={{color:'var(--yool-error)'}} />
      </div>
      <h3 className="text-lg font-medium mb-2" style={{color:'var(--yool-black)'}}>{title}</h3>
      <p className="mb-6" style={{color:'var(--yool-muted)'}}>{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center space-x-2 px-4 py-2 text-white rounded-lg transition-colors"
          style={{background:'var(--yool-error)'}}
        >
          <RefreshCw className="h-4 w-4" />
          <span>Reintentar</span>
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;